module.exports = __webpack_public_path__ + "img/6.656ca191.jpg";